import type { ReactNode } from 'react';

export const symbol_game_button_l1: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M585-563v200q0 9.78 7.16 16.89 7.16 7.11 17 7.11t16.84-7.11q7-7.11 7-16.89v-244.94q0-5.06-3.5-9.06-3.5-4-8.68-4H597q-1 0-8 3l-71 56q-6.55 5.08-7.77 13.54Q509-540 514-532.5t14 7.5q9 0 16-5l41-33ZM378-385v-209.64q0-11.36-7-18.36t-18-7q-11 0-18 7t-7 18v226q0 12.75 8.63 21.37Q345.25-339 358-339h120q10.12 0 16.56-6.42 6.44-6.41 6.44-16.5 0-10.08-6.44-16.58-6.44-6.5-16.56-6.5H378Zm502-355v426q0 63.52-44.5 108.76T727-160H233q-64 0-108.5-45.24T80-314v-426q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740Zm-60 0H140v426q0 38.77 27 66.39Q194-220 233-220h494q39 0 66-27.61 27-27.62 27-66.39v-426Zm0 0H140h680Z"
		/>
	</svg>
);
